module.exports = __webpack_public_path__ + "images/reporting/empty-state.svg";